export default "dist/images/components-columns-width-control-4-1-uneven.f368247.png";